
export default function ApplicationScenarios() {
  const scenarios = [
    {
      title: 'Mountain Retreats',
      description: 'Bring luxury living to mountain peaks and ridges where traditional construction is impossible. Perfect for alpine resorts and private getaways.',
      image: '/images/ai-luxury-modular-capsule-house-on-dramatic-5d1201.webp',
      features: ['High Altitude Ready', 'Wind Resistant', 'Thermal Insulation']
    },
    {
      title: 'Island Destinations',
      description: 'Transform remote islands into exclusive retreats. Components can be transported by small boats and assembled without heavy equipment.',
      image: '/images/ai-modern-modular-capsule-house-on-tropical-2cc12d.webp',
      features: ['Salt Air Resistant', 'Hurricane Rated', 'Beach Ready']
    },
    {
      title: 'Forest Sanctuaries',
      description: 'Nestled among ancient trees without disturbing the ecosystem. Minimal ground impact and no need for access roads.',
      image: '/images/ai-modern-modular-capsule-house-in-dense-fo-17282e.webp',
      features: ['Eco-Friendly', 'Low Impact', 'Nature Integrated']
    },
    {
      title: 'Desert Oasis',
      description: 'Create comfortable living spaces in arid environments. Enhanced insulation and climate control for extreme temperatures.',
      image: '/images/ai-modern-modular-capsule-house-in-desert-l-3de5a2.webp',
      features: ['Heat Resistant', 'Sand Sealed', 'Solar Ready']
    },
    {
      title: 'Cliff Edge Living',
      description: 'Perched on dramatic cliff edges with breathtaking views. Engineered for stability on challenging terrain.',
      image: '/images/ai-modern-modular-capsule-house-on-cliff-ed-4ac9a3.webp',
      features: ['Anchored Design', 'Panoramic Views', 'Stable Foundation']
    },
    {
      title: 'Arctic Expeditions',
      description: 'Withstand extreme cold with superior insulation. Perfect for research stations or adventure tourism in polar regions.',
      image: '/images/ai-modern-modular-capsule-house-in-arctic-s-aac9c9.webp',
      features: ['Extreme Cold Rated', 'Triple Insulation', 'Snow Load Ready']
    }
  ];

  return (
    <section id="applications" className="py-20 sm:py-28 lg:py-36 bg-gradient-to-b from-[#000000] via-[#0D1117] to-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6 text-white">
            Built for <span className="text-cyan-400">Anywhere</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            From mountain peaks to tropical islands, the M Series brings luxury living to locations 
            previously considered impossible for permanent structures.
          </p>
        </div>

        {/* Scenarios Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {scenarios.map((scenario, index) => (
            <div 
              key={index}
              className="group relative bg-black/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl overflow-hidden hover:border-cyan-500/50 hover:shadow-[0_0_30px_rgba(0,217,255,0.2)] transition-all duration-500"
            >
              {/* Image */}
              <div className="relative w-full h-56 overflow-hidden">
                <img 
                  src={scenario.image}
                  alt={scenario.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-medium text-white mb-3">{scenario.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed mb-4">{scenario.description}</p>
                
                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {scenario.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">Have a unique location in mind?</p>
          <a 
            href="/contact"
            className="inline-flex items-center gap-3 px-8 py-4 bg-cyan-500 text-black text-base font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.5)] whitespace-nowrap cursor-pointer"
          >
            Discuss Your Project
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
